<template>
  <header class="tabbar">
    <div
      class="item"
      v-for="(item, index) in state"
      :class="[index === selectedIdx ? 'active' : 'gray']"
      :style="index === 0 ? 'margin-left: 0' : ''"
      :key="item.code"
      @click="changeState(index)"
    >
      {{`${item.text}(${item.count})`}}
    </div>
  </header>
</template>

<script>
import { getClassCount } from '@/api/clockin';

export default {
  props: {
    defState: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      state: [
        {
          code: -1,
          text: '全部班级',
          count: 0
        },
        {
          code: 0,
          text: '未开营',
          count: 0
        },
        {
          code: 1,
          text: '进行中',
          count: 0
        },
        {
          code: 2,
          text: '已结营',
          count: 0
        }
      ],
      selectedIdx: 0,
    };
  },
  created() {
    const idx = this.state.findIndex(item => item.code === this.defState);

    this.selectedIdx = idx !== -1 ? idx : 0;

    getClassCount().then((data) => {
      const state = [
        {
          code: -1,
          text: '全部班级',
          count: data.all_count
        },
        {
          code: 0,
          text: '未开营',
          count: data.not_start_count
        },
        {
          code: 1,
          text: '进行中',
          count: data.start_count
        },
        {
          code: 2,
          text: '已结营',
          count: data.finish_count
        }
      ];

      this.state = state;
    });
  },
  methods: {
    changeState(index) {
      this.selectedIdx = index;
      this.$emit('myClick', this.state[index].code);
    }
  }
};
</script>

<style lang="stylus" scoped>
.tabbar {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 16px;
  width: 100%;
  background: #fff;

  .item {
    margin-left: 12px;
    padding: 6px 10px;
    background: #F6F7FA;
    border-radius: 2px;
    font-size: 12px;
  }
}

.gray {
  color: #999;
}

.active {
  color: #FF9645;
}
</style>
